// extracted by mini-css-extract-plugin
export var chevronLeft = "BackButton-module--chevronLeft--e3f20";
export var motionWrapper = "BackButton-module--motionWrapper--3b583";